export default { sha: 'daddbfc9640a54381d8c67fbe5de8f674a1d7283', buildNumber: 'undefined' }
